import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getMaxWidthOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { getTextAlignOptions } from "@circle-react-shared/BuilderUI/utils/textStyleHelpers";
import { TABLET_WIDTH } from "../../../Canvas/constants";
import checkImagePlaceholder from "../../CallToAction/CardCallToAction/check_image_placeholder.png";
import fileImagePlaceholder from "../../CallToAction/CardCallToAction/file_image_placeholder.png";
import supportImagePlaceholder from "../../CallToAction/CardCallToAction/support_image_placeholder.png";
import userImagePlaceholder from "../../CallToAction/CardCallToAction/user_image_placeholder.png";
import usersImagePlaceholder from "../../CallToAction/CardCallToAction/users_image_placeholder.png";
import videoImagePlaceholder from "../../CallToAction/CardCallToAction/video_image_placeholder.png";
import { createCardBlock } from "../../utils/layoutBlockHelpers";
import { getSalesBlockSecondaryStyleOptions } from "../constants";

const cards = [
  {
    image: {
      signedId: "",
      placeholder: userImagePlaceholder,
    },
    h5Text: "1:1 Coaching Sessions",
    pText:
      "12 personalized weekly coaching sessions to accelerate your progress and overcome obstacles.",
  },
  {
    image: {
      signedId: "",
      placeholder: fileImagePlaceholder,
    },
    h5Text: "Strategic Planning",
    pText:
      "A comprehensive 2-hour session to map out your personalized success blueprint.",
  },
  {
    image: {
      signedId: "",
      placeholder: videoImagePlaceholder,
    },
    h5Text: "Weekly Video Modules",
    pText:
      "Access to our complete library of training videos to support your development.",
  },
  {
    image: {
      signedId: "",
      placeholder: usersImagePlaceholder,
    },
    h5Text: "Private Community",
    pText:
      "Connect with like-minded professionals in our exclusive online community.",
  },
  {
    image: {
      signedId: "",
      placeholder: checkImagePlaceholder,
    },
    h5Text: "Accountability System",
    pText:
      "Weekly check-ins and our proprietary tracking system to ensure consistent progress.",
  },
  {
    image: {
      signedId: "",
      placeholder: supportImagePlaceholder,
    },
    h5Text: "VIP Support",
    pText:
      "Priority email access and personalized messaging between sessions for ongoing support.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "SalesBlock6",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "What is Included in Your Journey",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
        createPBlock({
          text: "Everything you need to transform your approach to success and fulfillment.",
          styles: {
            textAlign: getTextAlignOptions("center"),
            maxWidth: getMaxWidthOptions({
              defaultValue: `${TABLET_WIDTH}px`,
            }),
          },
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: cards.map(card => createCardBlock(card)),
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockSecondaryStyleOptions(),
      },
    },
  },
};
